import React from 'react';
import PropTypes from 'prop-types';

import {
  Box,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow
} from '@mui/material';

import { ChevronLeftOutlined } from '@mui/icons-material';

import { rxDialogStyles } from './RxDialogStyles';

const MedicationsList = ({ medications, selectedMedicationIds, onSelect }) => {
  return (
    <Box sx={rxDialogStyles.panel}>
      <Box sx={rxDialogStyles.panelHeader}>
        <Box sx={rxDialogStyles.panelTitle}>Medications</Box>
      </Box>

      <TableContainer sx={rxDialogStyles.tableContainer}>
        <Table size="small" sx={rxDialogStyles.availableTable}>
          <colgroup>
            <col style={{ width: '52%' }} />
            <col style={{ width: '20%' }} />
            <col style={{ width: '28%' }} />
          </colgroup>

          <TableBody>
            {medications.map(medication => {
              const disabled = selectedMedicationIds.includes(medication.id);

              return (
                <TableRow
                  key={medication.id}
                  hover={!disabled}
                  onClick={!disabled ? () => onSelect(medication) : undefined}
                  sx={[
                    !disabled && rxDialogStyles.availableMedicationRow,
                    disabled && rxDialogStyles.disabledMedicationRow
                  ]}>
                  <TableCell sx={rxDialogStyles.availableNameCell}>
                    <Box sx={rxDialogStyles.medicationNameWrapper}>
                      <IconButton
                        size="small"
                        aria-label={`Add ${medication.name}`}
                        disabled={disabled}
                        onClick={event => {
                          event.stopPropagation();
                          onSelect(medication);
                        }}
                        sx={
                          disabled
                            ? rxDialogStyles.disabledSelectMedicationButton
                            : rxDialogStyles.selectMedicationButton
                        }>
                        <ChevronLeftOutlined sx={{ fontSize: 20 }} />
                      </IconButton>

                      <Box
                        component="span"
                        title={medication.name}
                        sx={rxDialogStyles.medicationName}>
                        {medication.name}
                      </Box>
                    </Box>
                  </TableCell>

                  <TableCell sx={rxDialogStyles.availableDoseCell}>
                    {medication.dosage}
                  </TableCell>

                  <TableCell sx={rxDialogStyles.availableDirectionCell}>
                    {medication.directions}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

MedicationsList.propTypes = {
  medications: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
      name: PropTypes.string.isRequired,
      dosage: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      directions: PropTypes.string
    })
  ),
  selectedMedicationIds: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  ),
  onSelect: PropTypes.func
};

MedicationsList.defaultProps = {
  medications: [],
  selectedMedicationIds: [],
  onSelect: () => {}
};

export default MedicationsList;
